module.exports = __webpack_public_path__ + "static/media/Babysit.c1041f5c.png";